import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import type { EmailRemoverFormData } from '../types/removeEmail';

import { validateEmail } from './emailValidation';

const validationSchema: yup.ObjectSchema<EmailRemoverFormData> = yup
  .object()
  .shape({
    additionalEmail: yup
      .string()
      .test('additionalEmail', 'Enter valid email address', (email) =>
        validateEmail(email as string)
      )
      .defined(),
  })
  .defined();

export const validationResolver = yupResolver(validationSchema);
